export const translationKeys = {
  NAMESPACE: 'Radio_Button',
  INLINE_ERROR_MESSAGE_DEFAULT_ERROR_MESSAGE:
    'Radio_Button_On_Stage_Error_Text_Label',
  INLINE_ERROR_MESSAGE_DEFAULT_VALIDATION_MESSAGE:
    'Radio_Button_No_Selection_Validation_Message',
} as const;
